<template>
  <a class="button" :disable="disable" :class="btnStyle" href="javascript:;">{{text}}</a>
</template>

<script>
export default {
  props: {
    text: {
      default: '',
      type: String
    },
    btnStyle: {
      default: 'a',
      type: String
    },
    disable: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl'

.button
  text-decoration none
  display inline-block
  padding 0 20px
  line-height 26px
  height 26px
  text-align center
  box-sizing border-box
  &.a
    color #ffffff
    background $themeColor2
    font2()
    font-size 12px
  &.b
    line-height 23px
    height 24px
    font1()
    font-size 12px
    color $themeColor2
    background #ffffff
    border-radius 2px
    border 1px solid $themeColor2  
    padding: 0 3px;
    min-width: 75px;
  &[disable="true"]
    opacity .7
    cursor not-allowed
    
</style>




// WEBPACK FOOTER //
// src/components/base/button/Button.vue